function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// @mui imports
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
// @limitless
import AngleDown from "@limitless/icons/AngleDown";
import Typography from "../../data-display/typography/Typography";
import CloseIcon from "@limitless/icons/Close";
import InputLabel from "../input-label/InputLabel";
import CheckboxOutlineIcon from "@limitless/icons/CheckboxOutline";
import CheckedIcon from "@limitless/icons/Checked";
import { useTranslation } from "@limitless/common/hooks";
import CircularProgress from "@mui/material/CircularProgress";
const AutocompleteChip = styled(Chip)(({
  theme
}) => ({
  "& .MuiChip-deleteIcon": {
    color: theme.palette.primary.main,
    margin: "6px 5px 0px 0px",
    fontSize: "16px",
    "&:hover": {
      color: theme.palette.primary.main
    }
  }
}));
const AutoCompleteCheckbox = styled(Checkbox)(() => ({
  paddingLeft: "14px",
  paddingTop: "7px",
  paddingBottom: "7px",
  paddingRight: "10px",
  "&:hover": {
    backgroundColor: "transparent"
  }
}));
const DropdownMenu = ({
  id = "DropdownMenu-default-id",
  label = "",
  options,
  smallSize,
  disabled,
  textFieldProps,
  required = false,
  disableClearable = true,
  loading = false,
  placeholder,
  skinny,
  //selected = [],
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputLabel, {
    label: label,
    id: id,
    required: required,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(Autocomplete, _extends({
    id: id,
    disabled: disabled,
    popupIcon: /*#__PURE__*/React.createElement(AngleDown, null),
    renderInput: params => {
      var _rest$value;
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        placeholder: rest.multiple && ((_rest$value = rest.value) === null || _rest$value === void 0 ? void 0 : _rest$value.length) > 0 ? "" : t(placeholder)
      }, textFieldProps, {
        InputProps: {
          ...params.InputProps,
          endAdornment: /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(CircularProgress, {
            color: "inherit",
            size: 20
          }) : null, params.InputProps.endAdornment)
        }
      }));
    },
    defaultValue: [],
    options: options,
    openOnFocus: true,
    clearIcon: /*#__PURE__*/React.createElement(CloseIcon, {
      sx: {
        width: 16,
        height: 16,
        marginTop: "6px"
      }
    }),
    disableClearable: disableClearable,
    disableCloseOnSelect: rest.multiple,
    sx: {
      width: smallSize ? 112 : "auto"
    },
    componentsProps: {
      popper: {
        sx: {
          width: "fit-content"
        }
      }
    },
    renderTags: (value, getTagProps) => {
      return value.length === 0 ? placeholder : value.map((option, index) => /*#__PURE__*/React.createElement(AutocompleteChip, _extends({
        key: index,
        label: /*#__PURE__*/React.createElement(Typography, {
          variant: "body",
          sx: {
            color: theme => theme.palette.primary.main
          }
        }, option.label)
      }, getTagProps({
        index
      }), {
        variant: "outlined",
        deleteIcon: /*#__PURE__*/React.createElement(CloseIcon, null)
      })));
    },
    getOptionLabel: option => option.label || ""
    // eslint-disable-next-line consistent-return
    ,
    renderOption: (optionProps, option, {
      selected
    }) => {
      const multipleOptionProps = {
        ...optionProps
      };
      delete multipleOptionProps.className;
      if (rest.multiple) {
        return /*#__PURE__*/React.createElement("li", _extends({}, multipleOptionProps, {
          style: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: "4px"
          }
        }), /*#__PURE__*/React.createElement(AutoCompleteCheckbox, {
          icon: /*#__PURE__*/React.createElement(CheckboxOutlineIcon, {
            color: "primary",
            viewBox: "0 0 20 20",
            fontSize: "small"
          }),
          checkedIcon: /*#__PURE__*/React.createElement(CheckedIcon, {
            sx: {
              color: theme => theme.palette.primary.main
            }
          }),
          checked: selected,
          className: "DropdownCheck",
          disableRipple: true
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          color: "textPrimary"
        }, option.label));
      } else {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", optionProps, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          color: "textPrimary"
        }, option.label)));
      }
    },
    placeholder: placeholder,
    className: skinny && "skinny"
  }, rest)));
};
DropdownMenu.propTypes = {
  options: PropTypes.array.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  smallSize: PropTypes.bool,
  textFieldProps: PropTypes.object,
  required: PropTypes.bool,
  disableClearable: PropTypes.bool,
  placeholder: PropTypes.string,
  skinny: PropTypes.bool,
  selected: PropTypes.array,
  loading: PropTypes.bool
};
export default DropdownMenu;